/* ---------------------------------------------------------------------------
   ACCESS TIERS AND UNLOCK PRICES

   Everybody lands on the same URL. What a customer sees depends on the code
   they type into the second field of the gate:

     no code      basic    twelve books, eight bonuses, locked cards
     CREATOR      creator  + the Creator Pack (papercraft, calligraphy)
     PROKIT       pro      + the Creator Pack + the video workshop

   Put the matching code in the delivery email for each purchase.
   Change the codes whenever you like; only this file has to change.
--------------------------------------------------------------------------- */

export type Tier = 'basic' | 'creator' | 'pro'

export const CODES: Record<string, Tier> = {
  CREATOR: 'creator',
  PROKIT: 'pro',
}

/* Which locked packs each tier can open. */
export const GRANTS: Record<Tier, string[]> = {
  basic: [],
  creator: ['creator'],
  pro: ['creator', 'videos'],
}

export const TIER_LABEL: Record<Tier, string> = {
  basic: 'Mega Kit',
  creator: 'Mega Kit + Creator',
  pro: 'Pro Workshop',
}

export function tierFor(code: string): Tier {
  const key = code.trim().toUpperCase().replace(/[^A-Z0-9]/g, '')
  return CODES[key] ?? 'basic'
}

export function canOpen(tier: Tier, packId: string): boolean {
  return GRANTS[tier].includes(packId)
}

/* ---------------------------------------------------------------------------
   CHECKOUT LINKS for the locked cards.

   These prices are deliberately HIGHER than the order-bump and one-click
   prices at checkout. The checkout is the cheap moment; this is the
   second-chance moment. Do not make the two numbers the same.

     Creator Pack    $9.90 as a bump at checkout   ->  $19.90 here
     Video Workshop  $27 as the one-click upsell   ->  $29 here
     Both together                                     $39 here
--------------------------------------------------------------------------- */
export interface UnlockOffer {
  href: string
  price: string
}

export const UNLOCK: Record<string, UnlockOffer> = {
  creator: { href: '', price: '$19.90' },
  videos: { href: '', price: '$29' },
  everything: { href: '', price: '$39' },
  assessment: { href: '', price: '$197' },
}
